import React, { useState, useEffect } from 'react';
import { TopUpBalanceModal } from '../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { useSelectOffers } from '../../operacion/activacion/hooks/ActivacionHook';
import { MovInventory } from './MovInventory';
import Indicators from './Indicators';
import { OfferDashboard } from './OfferDashboard';
import { GraficaBalance } from './GraficaBalance';
import { Filter } from '../../inventario/productos/components/Filter';
import MisPlanes from './MisPlanes';

const DashboardPage: React.FC = () => {
  let fechaActual = new Date();
  let fecha_inicio_init = new Date(
    fechaActual.getFullYear(),
    fechaActual.getMonth(),
    1
  );
  let fecha_fin_init = new Date();
  const [dateState, setDateState] = useState<string[]>([]);
  const [initFilterValues, setInitFilterValues] = useState({
    offer_id: '',
    user_id: '',
    init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    filter: 0,
  });
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [offersCache, setOffersCache] = useState<any[]>([]);
  const { data: offers, loading } = useSelectOffers(
    offersCache.length === 0,
    'recharge'
  );

  useEffect(() => {
    if (offers.length > 0 && offersCache.length === 0) {
      setOffersCache(offers);
    }
  }, [offers]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
    if (values) {
      setDateState([values.init_date, values.end_date]);
    }
  };

  const handleFilterClean = () => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
      end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    }));
    setDateState([]);
  };

  return (
    <>
      <div className="row w-100 gx-2 justify-content-end me-3">
        {/* <div className="col-md-2 text-end w-125px mb-5">
          <Filter
            initFilterValues={initFilterValues}
            onCleanFilter={handleFilterClean}
            onSearchFilter={handleFilter}
          />
        </div> */}
      </div>
      <Indicators />
      {/* <div className="d-flex mt-5 mb-5 gap-4">
        <OfferDashboard />
      </div> */}
      <div className="row mb-9 mt-5">
        {/* <div className="col-12">
          <GraficaBalance />
        </div> */}
        <MisPlanes offers={offersCache} loading={loading} />
      </div>
      {/* <div className="mt-5 mb-5">
        <MovInventory />
      </div> */}
      <TopUpBalanceModal
        show={visivilityModal}
        handleClose={(updateData: boolean) => {
          setVisivilityModal(!visivilityModal);
        }}
      />
    </>
  );
};

export { DashboardPage };
